export function randnumber(length: number) {
  return Math.random().toString(16).substring(2, 2 + length)
}
export const maskEmail = (email: string): string => {
  const [localPart, domainPart] = email.split('@');
  const maskedLocalPart = localPart.substring(0, 2) + '****';
  const [domain, topLevelDomain] = domainPart.split('.');
  const maskedDomain = domain.charAt(0) + '****';
  return `${maskedLocalPart}@${maskedDomain}.${topLevelDomain}`;
};

export type HeadingMap = { [key: string]: string };

export const mapDataToHeadings = (data: any[], headingMap: HeadingMap): { [key: string]: any }[] => {
    return data.map(item => {
        let mappedItem: { [key: string]: any } = {};
        for (let heading in headingMap) {
            mappedItem[heading] = item[headingMap[heading]] || 'N/A';
        }
        return mappedItem;
    });
};
